export default (callback: (e) => {}) => {
  document.addEventListener("DOMContentLoaded", (event) => {
    callback(event);
  });
  window.onpageshow = function(event) {
    if (event.persisted) {
      callback(event);
    }
  };
}
